import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable()
export class APIURLConstantsService {
  public static _API_BASE_URL: string = environment['API_URL'];

  constructor() { }

}
